// extracted by mini-css-extract-plugin
export default {"item":"item---dqclC","content":"content---wJ8yl","creationLabel":"creationLabel---vJbZo"};